import { GetterTree } from 'vuex';

import {
  TeachersStateI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<TeachersStateI, RootStateI> = {
};
